import ReactPixel from 'react-facebook-pixel'

export const getCookieValue = (key: string) => {
  let cookieKey = key + '='
  let result = ''
  const cookieArr = document.cookie.split(';')

  for (let i = 0; i < cookieArr.length; i++) {
    if (cookieArr[i][0] === ' ') {
      cookieArr[i] = cookieArr[i].substring(1)
    }

    if (cookieArr[i].indexOf(cookieKey) === 0) {
      result = cookieArr[i].slice(cookieKey.length, cookieArr[i].length)
      return result
    }
  }
  return result
}

export const completeRegistrationTrack = () => {
  ReactPixel.track('CompleteRegistration', { content_name: 'sign-up' })
}
export const signUpBtnClick = () => {
  ReactPixel.trackCustom('SIGN_UP', {
    content_name: 'sign-up',
  })
}

export const signInBtnClick = () => {
  if (getCookieValue('_fbc')) {
    ReactPixel.trackCustom('AD_SIGN_IN', {
      content_name: 'sign-in',
    })
  } else {
    ReactPixel.trackCustom('SIGN_IN', {
      content_name: 'sign-in',
    })
  }
}

export const freeExperienceBtnClick = () => {
  ReactPixel.trackCustom('FREE_EXPERIENCE', {
    content_name: `free-experience`,
  })
}
export const adFreeExperienceBtnClick = () => {
  ReactPixel.trackCustom('AD_FREE_EXPERIENCE', {
    content_name: `ad-free-experience`,
  })
}

export const longFormCreateBtnClick = () => {
  ReactPixel.trackCustom('LONG_FORM_CERATE', {
    content_name: 'long-form',
  })
}

export const shortFormCreateBtnClick = () => {
  ReactPixel.trackCustom('SHORT_FORM_CERATE', {
    content_name: 'short-form',
  })
}

export const pointPurchaseBtnClick = (type: string) => {
  ReactPixel.trackCustom('PURCHASE_POINT', {
    content_name: 'point',
  })
}

export const planPurchaseBtnClick = () => {
  ReactPixel.trackCustom('PURCHASE_PLAN', {
    content_name: 'plan',
  })
}

export const purchaseTrack = ({
  value,
  contentName,
  contentType,
}: {
  value: number
  contentName: string
  contentType: string
}) => {
  ReactPixel.track('Purchase', {
    value: value, // 연간 가격 (예: 라이트 플랜)
    currency: 'KRW',
    content_name: contentName,
    content_type: contentType,
  })
}

export const purchasePoint = () => {
  ReactPixel.track('Purchase', { content_name: `point-utm` })
  ReactPixel.trackCustom('AD_PURCHASE_POINT', {
    content_name: 'point-utm',
  })
}

export const clickLogo = (customName: string, contentName: string) => {
  ReactPixel.trackCustom(customName, {
    content_name: contentName,
  })
}

export const initiateCheckoutTrack = ({
  value,
  contentName,
  contentType,
}: {
  value: number
  contentName: string
  contentType: string
}) => {
  ReactPixel.track('InitiateCheckout', {
    value: value, // 연간 가격 (예: 라이트 플랜)
    currency: 'KRW',
    content_name: contentName,
    content_type: contentType,
  })
}

// 초기화 시 어딘가에서 반드시 보조 픽셀도 init:
// (ReactPixel as any).fbq?.('init', FASHION_ID)

export const emailSubmitTrack = (opts?: { pixelId?: string }) => {
  const params = { submitted: true }

  const fbq = (ReactPixel as any).fbq
  // if (FASHION_ID && typeof fbq === 'function') {
  //   // 특정 픽셀 한정 커스텀 이벤트
  //   fbq('trackSingleCustom', FASHION_ID, 'EMAIL_SUBMIT', params)
  // }
}
